<template>
  <layout-component>
    <template v-if="bookingClosed">
      <div class="container">
        <div class="row pt-4 pt-md-4 pt-lg-5 pb-4">
          <div class="col-md-8 offset-md-2">
            <h3 class="left-bullet" v-html="$t('bookings-closed')"></h3>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <template v-if="$store.cart.content && $store.cart.content.length && $store.rooms.content">
        <div class="banner banner-blog">
          <div class="container">
            <div class="row">
              <div class="col-md-6 offset-md-3">
                <h1 class="left-bullet" v-html="$t('title-banner')"></h1>
              </div>
            </div>
          </div>
        </div>
      </template>
      <div class="container cart">
        <template v-if="$store.cart.content && $store.cart.content.length && $store.rooms.content">
          <div class="row">
            <div class="col-md-10">
              <b-list-group class="cart-list">
                <div v-for="(cartitem,index) in $store.cart.content" :key="index">

                  <!--
                    Rooms
                  -->
                  <b-list-group-item class="cart-item d-md-flex align-items-md-center justify-content-md-between" v-if="cartitem.room_id">
                    <div class="img-wrapper">
                      <div class="room-image" :style="'background-image:url('+$store.rooms.content[cartitem.room_id-1].images[0]+')'"></div>
                    </div>
                    <div class="text-wrapper d-md-flex align-items-md-start justify-content-md-between">
                      <div class="left-infos">
                        <h5>{{'title-room'|t}}</h5>
                        <div class="room-name">{{'title-room'|t}} n°{{cartitem.room_id}}</div>
                        <div class="booking-date">{{cartitem.date|formatDate}}</div>
                        <div class="booking-hours">{{'from'|t}} {{cartitem.from}}:00 {{'to'|t}} {{cartitem.to}}:00</div>
                        <div class="admin-comment" v-if="$auth.check(2)">Admin comment: {{cartitem.comment}}</div>
                      </div>
                      <div class="right-infos">
                        <template v-if="cartitem.price_reduced != null">
                        <div class="booking-price"><del>{{cartitem.price}}€</del> {{cartitem.price_reduced}}€</div>
                        </template>
                        <template v-else>
                        <div class="booking-price">{{cartitem.price}}€</div>
                        </template>
                        <div @click="deleteCartItem(cartitem.id)" class="trash-wrapper"><simple-svg :filepath="'/storage/img/icon/icon-trash.svg'" /></div>
                      </div>
                    </div>
                  </b-list-group-item>

                  <!--
                    Events
                  -->
                  <b-list-group-item class="cart-item d-md-flex align-items-md-center justify-content-md-between" v-else>
                    <div class="img-wrapper">
                      <div class="room-image" :style="`background-image:url('storage/${cartitem.event.cover}')`"></div>
                    </div>
                    <div class="text-wrapper d-md-flex align-items-md-start justify-content-md-between">
                      <div class="left-infos">
                        <h5>{{ $i18n.locale == 'fr' ? cartitem.event.category.name : cartitem.event.category.name_en }}</h5>
                        <router-link class="room-name" :to="/events/+cartitem.event.slug" active-class="active">{{cartitem.event.name}} (x{{ cartitem.tickets }})</router-link>

                        <div class="booking-date">{{cartitem.date|formatDate}}</div>
                        <div class="booking-hours">{{'from'|t}} {{cartitem.event.from | formatTimeEvent}} {{'to'|t}} {{cartitem.event.to | formatTimeEvent}}</div>
                      </div>
                      <div class="right-infos" v-if="cartitem.price">
                        <template v-if="cartitem.price_reduced != null">
                        <div class="booking-price"><del>{{cartitem.price}}€</del> {{cartitem.price_reduced}}€</div>
                        </template>
                        <template v-else>
                        <div class="booking-price">{{cartitem.price}}€</div>
                        </template>
                        <div @click="deleteCartItem(cartitem.id)" class="trash-wrapper"><simple-svg :filepath="'/storage/img/icon/icon-trash.svg'" /></div>
                      </div>
                      <div class="right-infos" v-else>
                        <div class="booking-price">{{'event-free'|t}}</div>
                        <div @click="deleteCartItem(cartitem.id)" class="trash-wrapper"><simple-svg :filepath="'/storage/img/icon/icon-trash.svg'" /></div>
                      </div>
                    </div>
                  </b-list-group-item>

                </div>
                <!-- Modal  -->
                <b-modal id="applyCoupon" ref="couponModale" size="lg" scrollable centered hide-footer hide-header content-class="edit-coupon">
                  <button type="button" aria-label="Close" class="close" @click="hideModal()">
                    <b-img src="/storage/img/icon/icon-cross-close-modal.svg" class="cross-close-modal" width="16" height="16" />
                  </button>

                  <div class="content">
                    <h3 class="left-bullet">{{'coupon-modal-title'|t}}</h3>
                    <p>{{'coupon-modal-text'|t}}</p>

                    <ul>
                      <li v-for="(cartitem, index) in filteredCartItems" :key="index">
                        <input type="radio" :id="'product-' + index" :value="cartitem.id" v-model="selectedProduct" />
                        
                        <label :for="'product-' + index">
                          <div v-if="cartitem.room_id">
                            <div class="room-name">{{'title-room'|t}} n°{{cartitem.room_id}}</div>
                            <div class="booking-date">{{cartitem.date|formatDate}}</div>
                            <div class="booking-hours">{{'from'|t}} {{cartitem.from}}:00 {{'to'|t}} {{cartitem.to}}:00</div>
                          </div>

                          <div v-else>
                            <div>{{ $i18n.locale == 'fr' ? cartitem.event.category.name : cartitem.event.category.name_en }}</div>
                            <div class="room-name">{{cartitem.event.name}} (x{{ cartitem.tickets }})</div>
                            <div class="booking-date">{{cartitem.date|formatDate}}</div>
                          </div>
                        </label>

                        <div class="booking-price">{{cartitem.price}}€</div>
                      </li>
                    </ul>

                    <button type="button" class="btn btn-primary mt-3" :disabled="!selectedProduct" @click="applyCoupon(), hideModal()"><span>{{'coupon-modal-submit'|t}}</span></button>
                  </div>
                </b-modal>
              </b-list-group>
            </div>
          </div>

          <div v-if="$auth.check(2)" class="row d-flex justify-content-center pt-1 pb-4 pt-md-3">
              <div class="col-md-6 go-checkout-wrapper">
                <div class="price-wrapper text-md-center">
                  <p class="cart-total"><span class="cart-total-price">{{ $store.cart.total.toLocaleString() }}€</span></p>
                  <p class="cart-vat">{{'included-vat'|t}} {{($store.cart.total-$store.cart.total/1.17).toFixed(2)}}€</p>
                </div>
                <b-button @click.once="confirmBooking()" class="submit">
                  <span>Confirm admin booking</span>
                </b-button>
                <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0 w-100" to="/book" active-class="active"><span>{{'continue-btn'|t}}</span></router-link>
            </div>
          </div>
          <div v-else class="row d-flex justify-content-center pt-1 pb-4 pt-md-3">
              <div class="col-md-8 col-lg-6 go-checkout-wrapper">
                <div class="price-wrapper text-md-center">
                  <p class="cart-total"><span class="cart-total-price">{{$store.cart.total.toLocaleString()}}€</span></p>
                  <template v-if="$store.user.coupon_id">
                    <p class="cart-coupon">{{'active-coupon-code'|t}} {{$store.user.coupon.code}} (-{{$store.user.coupon.discount}}{{$store.user.coupon.mode|t}})</p>
                  </template>
                  <p class="cart-vat">{{'included-vat'|t}} {{($store.cart.total-$store.cart.total/1.17).toFixed(2)}}€</p>
                  <p v-if="$store.user.balance > 0">
                    {{'user-balance'|t}}: {{$store.user.balance}}€
                  </p>
                </div>
                <form class="coupon-wrapper row" @submit.prevent="applyCoupon">
                  <div class="form-group col" :class="{ 'has-error': has_error }">
                      <label for="coupon-code">{{'label-coupon-code'|t}}</label>
                      <div class="input-wrapper">
                        <b-form-input type="text" id="coupon-code" v-model="couponcode"></b-form-input>
                        <span class="focus-border"></span>
                      </div>
                      <small class="form-text text-danger" v-if="has_error">{{has_error|t}}</small>
                  </div>
                  <div class="form-group col">
                      <b-button @click="applyCoupon" class="apply" v-bind:disabled="couponcode === ''"><span>{{'apply-coupon-code'|t}}</span></b-button>
                  </div>
                </form>
                <div class="checkbox-wrapper pt-2 pb-2 pt-md-3">
                    <b-form-checkbox id="agreerules" name="agreerules" value="agreerules" v-model="agreerules" unchecked-value="" class="cart-agreerules">
                      <span v-html="$t('checkbox-terms-of-use')"></span>
                      <div v-html="$t('checkbox-terms-of-use-link')"></div>
                      <span class="required">*</span>
                    </b-form-checkbox>

                    <b-form-checkbox id="agreeterms" name="agreeterms" value="agreeterms" v-model="agreeterms" unchecked-value="">
                      {{'checkbox-cookie-policy'|t}} <span class="required">*</span>
                    </b-form-checkbox>
                </div>
                <b-button @click.once="openStripeCheckout()" class="submit" v-bind:disabled="!agreerules || !agreeterms">
                  <template v-if="isHidden"><span class="text">{{'cart-btn-loading'|t}}</span> <loader /></template>
                  <template v-else><span>{{'cart-btn'|t}}</span></template>
                </b-button>
                <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0 w-100" to="/book" active-class="active"><span>{{'continue-btn'|t}}</span></router-link>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="row pt-4 pt-md-4 pt-lg-5 pb-4">
            <div class="col-md-8 offset-md-2">
              <h3 class="left-bullet" v-html="$t('empty-title')"></h3>
              <p>{{'empty-text'|t}}</p>
              <router-link class="btn mt-2 mt-md-3 mb-2 mb-md-0" to="/book" active-class="active"><span>{{'empty-btn'|t}}</span></router-link>
            </div>
          </div>
        </template>
      </div>
    </template>
	</layout-component>
</template>

<script>
    export default {
        data() {
          return {
            bookingClosed: false, //Set to true to disable bookings (COVID-19)
            isHidden: false,
            agreerules: false,
            agreeterms: false,
            has_error: false,
            couponcode: '',
            selectedProduct: '',
            selectedProductModal: false,
            coupon: null,
          }
        },
        methods: {
          deleteCartItem(cartid) {
            Vue.axios.delete('/cart/'+cartid).then(({data}) => {
              this.$store.setCart(data)
              this.$store.reloadUser()
            })
          },
          hideModal() {
            this.$refs.couponModale.hide()
          },
          applyCoupon() {
            Vue.axios.post('/apply-coupon', {
              'coupon': this.couponcode,
              'product': this.selectedProduct
            }).then(({data}) => {
              if(data.hasOwnProperty('error')) {
                if(data.hasOwnProperty('coupon')) {
                  this.coupon = data.coupon;
                  this.selectedProductModal = true;
                  this.$bvModal.show('applyCoupon');
                } else {
                  this.has_error = data.error;
                }
              } else {
                this.has_error = false
                this.couponcode = '';
                this.selectedProduct = '';
                this.$store.reloadUser()
                this.$store.loadCart()
              }
            })
            .catch((error) => {
              if (error.response && error.response.data && error.response.data.errors) {
                this.has_error = Object.values(error.response.data.errors).flat().join(', ');
              } else {
                this.has_error = "Une erreur s'est produite lors de l'application du coupon. Veuillez réessayer.";
              }
            });
          },
          openStripeCheckout() {
            this.isHidden = true
            Vue.axios.post('/order', {}).then(({data}) => {
              if (typeof data.total != "undefined" && data.total < 0.50) {
                this.$store.loadCart()
                this.$router.push('/booking-success')
              } else {
                stripe.redirectToCheckout({
                  sessionId: data.id
                }).then(function (result) {
                });
              }
            })
          },
          confirmBooking() {
            Vue.axios.post('/order', {}).then(({data}) => {
              this.$store.loadCart()
              this.$router.push('/admin')
            })
          }
        },
        computed: {
          filteredCartItems() {
            if (!this.coupon || !this.coupon.product_type) {
              return this.$store.cart.content;
            }
            return this.$store.cart.content.filter(cartitem => {
              if (this.coupon.product_type === 'event') {
                return cartitem.event;
              } else if (this.coupon.product_type === 'room') {
                return cartitem.room_id;
              }
              return true;
            });
          }
        },
        mounted() {
          this.$store.loadCart()
        }
    }
</script>


<i18n>
    {
      "en": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>My cart</span></span>",
        "from": "From",
        "to": "To",
        "included-vat": "Included in this price: 17% VAT =",
        "checkbox-terms-of-use": "All our rooms and studios are non-smoking areas. No food or drinks (beside those contained in bottles with re-sealable lids) are allowed inside the rooms; please consume them in the lounge area. Take care of the equipment as if it was yours.<br>Room booking cancellation is possible up to 24 hours before the date of the session (refund of 50%). Event bookings are non-refundable.",
        "checkbox-terms-of-use-link": "Please read the full <a href='/terms-of-use' target='_blank'>terms of use.</a>",
        "checkbox-cookie-policy": "By processing your order, you agree to Sonotron Terms of use, Privacy Policy and Cookies policy.",
        "cart-btn": "Check Out Now",
        "cart-btn-loading": "Loading",
        "empty-title": "<span class='title-anim-wrapper'><span class='title-anim'>Your cart is empty</span></span>",
        "empty-text": "Find a room that works around your life & budget.",
        "empty-btn": "Book a room",
        "label-coupon-code": "Coupon code",
        "error-coupon-invalid": "This code is invalid",
        "error-coupon-expired": "This code has expired",
        "error-coupon-used": "This code has already been used",
        "error-coupon-waiting": "This coupon has already been used on a pending order. It will be available again soon.",
        "active-coupon-code": "Active coupon code:",
        "apply-coupon-code": "Apply",
        "percent": "%",
        "decrease": "€",
        "bookings-closed": "We are temporarily closed. We apologize.<br /> Stay safe.",
        "title-room": "Room",
        "title-event": "Event",
        "event-free": "Free",
        "continue-btn": "Continue booking",
        "coupon-modal-title": "Select a product",
        "coupon-modal-text": "Please select the product you want to apply the coupon to.",
        "coupon-modal-submit": "Apply coupon",
        "user-balance": "Gift card balance"
      },
      "fr": {
        "title-banner": "<span class='title-anim-wrapper'><span class='title-anim'>Mon panier</span></span>",
        "from": "De",
        "to": "À",
        "included-vat": "Inclus dans ce tarif : TVA à 17 % =",
        "checkbox-terms-of-use": "Toutes nos salles ainsi que notre studio sont non-fumeur. Il est interdit d’y introduire à manger ou à boire (l’espace lounge est prévu à cet effet). Prenez soin de l’équipement comme si c’était le vôtre. Vous pouvez annuler votre réservation de salle jusqu’à 24 heures avant la date de la séance (remboursement à hauteur de 50 %).<br> Les réservations d'évènements ne sont pas remboursables.",
        "checkbox-terms-of-use-link": "Veuillez lire l’intégralité du règlement dans nos <a href='/terms-of-use' target='_blank'>conditions d'utilisation</a>.",
        "checkbox-cookie-policy": "En validant votre commande, vous acceptez les conditions d’utilisation, la politique de confidentialité et la politique relative aux cookies du Sonotron.",
        "cart-btn": "Commander maintenant",
        "cart-btn-loading'": "Chargement en cours",
        "empty-title": "<span class='title-anim-wrapper'><span class='title-anim'>Votre panier est vide.</span></span>",
        "empty-text": "Trouvez la salle idéale pour vous et votre budget.",
        "empty-btn": "Réserver une salle",
        "label-coupon-code": "Code promo",
        "error-coupon-invalid": "Ce code n'est pas valide",
        "error-coupon-expired": "Ce code est expiré",
        "error-coupon-used": "Ce code a déjà été utilisé",
        "error-coupon-waiting": "Ce coupon a déjà été utilisé sur une commande en attente de validation. Veuillez attendre que le coupon soit débloqué et réessayer.",
        "active-coupon-code": "Code promo actif :",
        "apply-coupon-code": "Appliquer",
        "percent": "%",
        "decrease": "€",
        "bookings-closed": "Nous sommes temporairement fermés. Veuillez nous excuser.<br /> Prenez soin de vous.",
        "title-room": "Salle",
        "title-event": "Événement",
        "event-free": "Gratuit",
        "continue-btn": "Continuer mes réservations",
        "coupon-modal-title": "Sélectionner un produit",
        "coupon-modal-text": "Veuillez selectionner le produit sur lequel vous souhaitez appliquer votre coupon.",
        "coupon-modal-submit": "Appliquer le coupon",
        "user-balance": "Solde carte cadeau"
      }
    }

  </i18n>
